module.exports = __webpack_public_path__ + "img/3.b10206c4.png";